<template>
  <div class="home">
    <div class="top-wrapper">
      <img
        class="top-img"
        src="@/static/img/home/banner-1.png"
      >
      <search-input @search-by-keyword="searchByKeyword" />
      <statistics-list v-if="level === 1" />
      <img
        class="cloud-bg"
        src="@/static/img/home/home-cloud.png"
      >
      <img
        src="@/static/img/home/home-bottom-bg.png"
        class="home-bottom-bg"
      >
      <type-list />
    </div>
    <!-- 热词搜索 -->
    <hot-search v-if="level !== 3" />
    <!-- 热词雷达 -->
    <hot-radar
      v-if="level !== 3"
      @search-by-keyword="searchByKeyword"
    />
    <!-- 底部介绍 -->
    <flex
      justify="between"
      align="center"
      class="footer">
      <img src="@/static/img/home/16.png">
      <div class="footer-text">
        <p>主办：中共贵州省委宣传部</p>
        <p>承办：多彩贵州网有限责任公司</p>
        <p>黔ICP备15002649号-4</p>
      </div>
      <img src="@/static/img/home/17.png">
    </flex>
    <!-- <img
      style="width: 100%;"
      src="@/static/img/home/home-bottom-img1.png"
    > -->
    <back-top />
  </div>
</template>

<script>
import SearchInput from '@/components/Home/SearchInput'
import StatisticsList from '@/components/Home/StatisticsList'
import TypeList from '@/components/Home/TypeList'
// import HotSearch from '@/components/Home/HotSearch'
// import HotRadar from '@/components/Home/HotRadar'

export default {
  components: {
    SearchInput,
    StatisticsList,
    TypeList,
    HotSearch: () => import('@/components/Home/HotSearch'),
    HotRadar: () => import('@/components/Home/HotRadar')
  },
  computed: {
    level () {
      return this.$route.query.level ? Number(this.$route.query.level) : 1
    }
  },
  mounted () {
    // 初次进入到搜索结果页时滚动到最顶部
    document.documentElement.scrollTop = 0
  },
  methods: {
    searchByKeyword (keyword) {
      this.$router.replace({
        path: '/list',
        query: {
          keyWord: keyword,
          ...this.$options.filters.keepURLParams(this)
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.home
  // overflow-x hidden
  text-align center
  background #fff
.top-wrapper
  position relative
  width 100%
  height 1000px
.top-img
  width 100%
  height 900px
.cloud-bg
  position absolute
  width 100%
  bottom 40px
  left 0px
  margin-right 1000px
  // animation move .2s infinite
// @keyframes move {
// 0% { bottom: 40px; }
// 10% { bottom: 45px; }
// 20% { bottom: 50px; }
// 30% { bottom: 55px; }
// 40% { bottom: 60px; }
// 50% { bottom: 65px; }
// 60% { bottom: 60px; }
// 70% { bottom: 55px; }
// 80% { bottom: 50px; }
// 90% { bottom: 45px; }
// 100% { bottom: 40px; }
// }
.home-bottom-bg
  position absolute
  bottom 0px
  left 0px
  width 100%

.footer
  padding 40px 18% 40px 18%
  border-top 3px solid #BE1610
  p
    cursor pointer
    margin-bottom 10px
    font-size 14px
    &:hover
      color #CF1922
  img
    flex none
</style>
